export const FETCH_USER_DATA = '/api/public/selfregister';
export const FETCH_MASTERDATA = '/api/public/metadata';
export const CREATE_USER = '/api/public/selfregister';
export const GET_UPLOAD_IMAGE_URL = '/api/public/getFileUploadUrl';
export const GET_DOWNLOAD_IMAGE_URL = '/api/public/getFileDownloadUrl';
export const DELETE_IMAGE = '/api/public/deleteFile';
export const DOWNLOAD_IMAGE = '/api/public/getFileDownloadUrl';
export const VALIDATE_KYC = '/api/public/validateIndividualKyc';
export const GET_CITY_STATE = '/api/public/autopopulateStateCity';
